import { render } from "./ProjectPublicationEditorSuccess.vue?vue&type=template&id=0d955c03"
const script = {}

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__